import Vue from "vue";
import VueRouter from "vue-router";

import AuthLayout from "@/pages/Pages/AuthLayout.vue";

import ConfirmEmail from "@/pages/Pages/ConfirmEmail.vue";
import Register from "@/pages/Pages/Register.vue";
import RegisterAdmin from "@/pages/Pages/RegisterAdmin.vue";
import ResetPassword from "@/pages/Pages/ResetPassword.vue";

import NotFound from "@/pages/Pages/NotFound.vue";

Vue.use(VueRouter);

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "confirm-email",
      name: "confirm-email",
      component: ConfirmEmail,
    },
    {
      path: "register",
      name: "register",
      component: Register,
    },
    {
      path: "register-admin",
      name: "register-admin",
      component: RegisterAdmin,
    },
    {
      path: "reset-password",
      name: "reset-password",
      component: ResetPassword,
    },
    {
      path: "error-404",
      name: "error-404",
      component: NotFound,
    },
  ],
};

const routes = [
  {
    path: "/",
    redirect: "/error-404",
    name: "Home",
  },
  authPages,
  {
    path: "*",
    redirect: "/error-404",
  },
];

const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  //linkExactActiveClass: "nav-item active",
});

export default router;
